module.exports = "<h2 class=\"header-major\">Edit {{template?.templateName}}</h2>\r\n<app-thought-form *ngIf=\"template\"\r\n  [thought]=\"template\"\r\n  isTemplateForm=\"true\"\r\n  (templateSaved)=\"templateSaved($event)\"\r\n  (templateCancelled)=\"templateCancelled($event)\"\r\n  (templateDeleted)=\"templateDeleted($event)\"></app-thought-form>\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/thought-template/template-edit/template-edit.component.html
// module id = ../../../../../src/app/thought-module/thought-template/template-edit/template-edit.component.html
// module chunks = main